import { render } from "./Recommendation.vue?vue&type=template&id=38155f69&scoped=true"
import script from "./Recommendation.vue?vue&type=script&lang=js"
export * from "./Recommendation.vue?vue&type=script&lang=js"

import "./Recommendation.vue?vue&type=style&index=0&id=38155f69&scoped=true&lang=less"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-38155f69"]])

export default __exports__